module.exports = __webpack_public_path__ + "media/components/participants_components/static/Path2-f0ea7069a9f10d28be64b35f61bc8772.png";